<template>
  <v-sheet class="text-center d-flex flex-column align-center bg-background text-on-surface-variant">
    <span class="title font-weight-bold mb-3 mt-2">Dicas de segurança</span>
    <span>Nenhum seguro cobre tudo.</span><br>
    <span>Seguindo as dicas abaixo, mesmo que não seja um expert nas coberturas e exclusões, você terá muito menos chances
      de precisar acionar o seguro ou pior, perder a cobertura concedida pela seguradora.</span>
    <br>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Não compre ou use cadeados de cabo de aço (aqueles de espiral).</b> Cadeados de cabo de aço oferecem um nível
      muito reduzido de segurança devido à sua baixa resistência a arrombamentos e, por esta razão, não estão amparados
      nesta apólice de seguro. Sua bike é um bem muito valioso. Proteja-a com um bom cadeado ou trava apropriada.
      Procure no seu Bike Shop um modelo robusto. Há excelentes opções por menos de R$100,00.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Nunca estacione e deixe a sua bike desassistida em um rack veicular.</b> Sua bike exposta em um rack sem
      ninguém por perto é a vitrine perfeita para um ladrão oportunista. O seguro de bicicleta intermediado pela Velo
      Seguros não irá dar cobertura para subtração nestas condições. Prefira guardar a bicicleta dentro do carro e fique
      atento para estacionar em locais com circulação de pessoas e, preferencialmente, que estejam vigiados por câmeras
      de vigilância. Lembre-se: pernoitar com a sua bike dentro do carro ou no rack é entregar o “ouro pro bandido”
      (agravamento do risco) e a seguradora não irá te amparar.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Prefira guardar sua bicicleta dentro de casa.</b> Sua casa é o local mais seguro tanto para você, quanto para
      sua bike. Contudo, nós sabemos que nem sempre é possível guardar a sua bike tão perto de você. Se for
      guardar em uma garagem, você precisa deixá-la presa pelo quadro a um objeto irremovível (algo chumbado na parede,
      por exemplo), com um cadeado ou trava apropriada. Verifique se o bicicletário onde irá guardá-la é guarnecido por
      câmeras de segurança. Como falaremos a seguir, seguradoras dependem de materialidade para aprovarem facilmente uma
      indenização.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Comprovação, Materialidade, evidências, esta é a chave de tudo.</b> Lembre-se, seguradoras dependem do máximo
      de provas materiais para regular o sinistro e aprovar uma indenização. Portanto, qualquer evento que aconteça com
      você, seja um assalto, subtração ou dano acidental, pense que todos os elementos que puder reunir irão tornar o
      processo claro e com provas robustas. Câmeras de vigilância são perfeitas para ajudar nesta hora, bem como fotos,
      vídeos, e é claro, faça um boletim de ocorrência completo, com detalhes da ocorrência, local e hora, e não esqueça
      de informar a marca, modelo, ano e número de série da sua bike. Ah, muito importante. Seja rápido! Não perca tempo
      e faça na hora um boletim de ocorrência e avise imediatamente a seguradora. Quem sabe dá tempo de tudo se salvar?
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Seja cuidadoso como se não tivesse seguro.</b> O comportamento cuidadoso é essencial para evitar os transtornos
      de acionar um seguro. Quando sua bike não estiver com você, ela deve estar protegida. Quando estiver fora de casa,
      ela deve estar trancada. Quando estiver se divertindo, não tire os olhos da sua bike. Pode ser que tenha mais
      gente de olho.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Minha bike simplesmente desapareceu.</b> Dá arrepios só de pensar. Leia novamente a dica de número 4 sobre
      materialidade. O simples desaparecimento da sua bike impedirá que a seguradora indenize sua perda. Se você seguir
      as dicas acima, não haverá “sumiço” sem arrombamento, sem evidências, sem materialidade.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Vai guardar sua bike em um bicicletário?</b> Se liga nesta dica de ouro: Escolha a melhor bike do bicicletário
      com o pior cadeado e estacione bem ao lado dela. Possivelmente, o “sorteado” será o seu vizinho. Pense que
      bandidos estão preparados para cortar cadeados de cabo de aço em segundos, e não para perder minutos serrando um
      cadeado ou trava apropriada, o que aumentaria o risco de serem pegos. Se estacionar sempre em um mesmo bicicletário, cobre que
      ele tenha uma câmera apontada para o local onde as bicicletas estão guardadas. Isto deixará você completamente
      tranquilo, pode apostar.
    </span>
    <v-divider class="my-4" width="40%" />
  </v-sheet>
</template>
<script>
  export default {}
</script>
<style scoped>
span {
  font-weight: 300;
}
b {
  font-weight: bold;
}
</style>
